import { render, staticRenderFns } from "./AutoScale.vue?vue&type=template&id=2f1f14ae&"
import script from "./AutoScale.vue?vue&type=script&lang=js&"
export * from "./AutoScale.vue?vue&type=script&lang=js&"
import style0 from "./AutoScale.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports